import { render, staticRenderFns } from "./resourceMobileList.vue?vue&type=template&id=028170e0&scoped=true&"
import script from "./resourceMobileList.vue?vue&type=script&lang=js&"
export * from "./resourceMobileList.vue?vue&type=script&lang=js&"
import style0 from "./resourceMobileList.vue?vue&type=style&index=0&id=028170e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028170e0",
  null
  
)

export default component.exports